import "./input.scss";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Button from "@mui/material/Button";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import SendIcon from "@mui/icons-material/Send";
import HomePageContext from "../HomePageContext";

const Input = () => {
  const sendMsg = "https://proxy-api.cyxym.net/app/v1?chat";
  const token = localStorage.getItem("token");

  const [text, setText] = useState("");
  const [img, setImg] = useState([]);

  const inputRef = useRef(null);
  const isSendingRef = useRef(false); // жёсткая защита

  const { getMessages, sending, setSending } = useContext(HomePageContext);

  const handleSend = useCallback(
    async (files = []) => {
      const messageText = text.trim();
      const hasContent = messageText || files?.length > 0;

      if (!hasContent || isSendingRef.current || sending) return;

      // === Optimistic UI ===
      setSending(true);
      isSendingRef.current = true;

      const tempText = messageText; // сохраняем текст
      const tempFiles = [...files]; // сохраняем файлы

      // Мгновенно очищаем поле
      setText("");
      setImg([]);

      try {
        const body = new FormData();
        body.append("token", token);
        body.append("message", tempText);

        for (let i = 0; i < tempFiles.length; i++) {
          body.append(`file${i}`, tempFiles[i]);
        }

        await fetch(sendMsg, {
          method: "POST",
          body
        });

        await getMessages();
      } catch (err) {
        console.error("Ошибка отправки:", err);
      } finally {
        setSending(false);
        isSendingRef.current = false;
      }
    },
    [text, token, getMessages, sending, setSending]
  );

  // Enter
  useEffect(() => {
    const listener = event => {
      if (
        event.code === "Enter" &&
        document.activeElement === inputRef.current &&
        !event.shiftKey
      ) {
        event.preventDefault();
        handleSend(img);
      }
    };

    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
  }, [handleSend, img]);

  const handleFileChange = e => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      handleSend(files);
    }
    e.target.value = "";
  };

  return (
    <div className="input">
      <TextareaAutosize
        onChange={e => setText(e.target.value)}
        value={text}
        placeholder="Сообщение..."
        ref={inputRef}
        maxRows={3}
        className="textArea"
        disabled={sending}
      />

      <div className="send">
        <input
          type="file"
          style={{ display: "none" }}
          id="file"
          multiple
          accept="image/png, image/jpeg, image/gif"
          onChange={handleFileChange}
        />
        <label htmlFor="file">
          <AttachFileIcon className="img" />
        </label>

        <Button
          className="button"
          onClick={() => handleSend(img)}
          disabled={sending || (!text.trim() && img.length === 0)}
        >
          {sending ? "Отправка..." : <SendIcon className="sendIcon" />}
        </Button>
      </div>
    </div>
  );
};

export default Input;
